export default "__VITE_ASSET__BU6LFtXk__"